import { Component, EventEmitter, Output } from "@angular/core";
import { UserRelationship } from "@apiserver-rest/ponder-data-client-base";

@Component({
    template: "",
    standalone: false
})
export class ProfileEvents {
    @Output()
    public hideProfileFormEvent: EventEmitter<any> = new EventEmitter();

    @Output()
    public profileAvatarUpdatedEvent: EventEmitter<any> = new EventEmitter();

    @Output()
    public addFriendEvent: EventEmitter<string> = new EventEmitter();

    @Output()
    public friendInviteSentEvent: EventEmitter<UserRelationship> = new EventEmitter();

    @Output()
    public friendInviteAcceptedEvent: EventEmitter<UserRelationship> = new EventEmitter();

    @Output()
    public friendDeletedEvent: EventEmitter<UserRelationship> = new EventEmitter();

    @Output()
    public displayNameUpdatedEvent: EventEmitter<string | undefined> = new EventEmitter();
}